module.exports = __webpack_public_path__ + "img/H5.9b01af33.png";